import type { DiscoveredRouteModule } from '@/router/generator/types';
import { defineAsyncComponent, markRaw } from 'vue';

const PortalAddressBookView = () => import('@/views/portal/AddressBookView.vue');
const PortalAddressBookIndexHeaderComponent = defineAsyncComponent(() => import('@/components/app/portal/address-book/IndexHeader.vue'));

export const NAME_PORTAL_ADDRESS_BOOK = 'PortalAddressBook';
export const PATH_PORTAL_ADDRESS_BOOK = 'portal/addressBook';

export const route: DiscoveredRouteModule = {
  id: 'app.portal.address_book',
  scope: 'app',
  moduleKey: 'address_book',
  name: NAME_PORTAL_ADDRESS_BOOK,
  path: PATH_PORTAL_ADDRESS_BOOK,
  component: PortalAddressBookView,
  meta: {
    dynamicComponent: markRaw(PortalAddressBookIndexHeaderComponent),
    requiresAuth: true, dataLoaders: ['project_document', 'features', 'portal_base']
  },
  requiresFeature: 'address_book'
};


